import { render, staticRenderFns } from "./yqyy.vue?vue&type=template&id=16448782&scoped=true"
import script from "./yqyy.vue?vue&type=script&lang=js"
export * from "./yqyy.vue?vue&type=script&lang=js"
import style0 from "./yqyy.vue?vue&type=style&index=0&id=16448782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16448782",
  null
  
)

export default component.exports